const en = require('./en.json');
const ptBr = require('./pt-BR.json');

export {
  en,
  ptBr,
}